module.exports = "/images/placeholder-yapdomik.svg?090abffddff486e33cdefc4865a14858";